import { formDataToObject, ICity, ISharedConfig, setDialog, setSnackbar } from '@shared/library';
import axios, { AxiosError } from 'axios';
import moment from 'moment';
import React from 'react';
import { excludedWfmPlanningColumns } from '../Planning';
import config from './../../../../../../../../config';
import { setFreePlanName } from './../../methods';
import { interventionColumns } from './../../static';
//#region COMPONENTS 
import GestDataGrid from '@shared/library/dist/components/gest/GestDataGrid/GestDataGrid';
import GestSaveButton from '@shared/library/dist/components/gest/GestInputs/button/save/GestSaveButton';
import GestDatePicker from '@shared/library/dist/components/gest/GestInputs/pickers/date/GestDatePicker';
import GestTextArea from '@shared/library/dist/components/gest/GestInputs/text area/GestTextArea';
//#endregion
//#region MODELS
import { IGestSelectOption } from '@shared/library/dist/components/gest/GestInputs/select/GestSelectProps';
import { IPlan } from '../../_models/Plan';
//#endregion
//CONTEXTS

interface IPlanningCommonFormProps {
    config: ISharedConfig,
    lang?: any;
    plan?: IPlan;
    existingPlans?: IPlan[];
    onSuccess: () => void;
}

export interface ICreatePlanFormProps extends IPlanningCommonFormProps {
    cities: IGestSelectOption<ICity>[],
    hiddenColumns: any;
}

const CreatePlanForm = (props: ICreatePlanFormProps) => {
    //STATES
    const [planName, setPlanName] = React.useState(props.plan?.name || `Piano ${(props.existingPlans?.length ?? 0) + 1}`);
    const [loading, setLoading] = React.useState(false);
    const createForm = React.useRef<HTMLFormElement>(null);

    //METHODS
    const createPlanAPI = (event: React.SubmitEvent<HTMLFormElement>) => {
        event.preventDefault();
        const newPlan = formDataToObject<IPlan>(createForm.current);

        if (newPlan) {
            setLoading(true);
            return axios.post(`${config.api.internal}/WFM/Plan/Create`, { ...newPlan, interventions: props.plan?.interventions }, { withCredentials: true })
                .then(() => {
                    props.onSuccess();

                    setDialog(props.config);
                    setSnackbar(props.config, { message: props.lang?.successfully_created, severity: 'success' });
                })
                .catch((error: AxiosError) => {
                    console.error(error);
                    setSnackbar(props.config, { message: "Errore durante la creazione del nuovo piano", severity: 'error' });
                })
                .finally(() => setLoading(false));
        }
    };

    return <>
        <form ref={createForm} onSubmit={createPlanAPI} style={{ flexDirection: "row", gap: "10px" }}>
            <GestTextArea
                name="name"
                label={props.lang?.plan_name}
                value={planName}
                onchange={newValue => {
                    newValue = newValue || "";

                    if (planName.toLowerCase().includes("free")) {
                        newValue = setFreePlanName(newValue);
                    }

                    setPlanName(newValue);
                }}
                required
                w={250}
            />

            <GestDatePicker
                name="notice_date"
                label={props.lang?.notice_date}
                value={new Date()}
                required
            />

            <GestDatePicker
                name="start_date"
                label={props.lang?.start_date}
                value={new Date()}
                required
            />

            <GestDatePicker
                name="end_date"
                label={props.lang?.end_date}
                value={moment(new Date()).add(1, "M").toDate()}
                required
            />
        </form>

        <GestDataGrid
            columns={interventionColumns({ ...props, plans: props.existingPlans, excluded: [...excludedWfmPlanningColumns, "intervention_id"] })}
            rows={props.plan?.interventions}
            columnVisibilityModel={props.hiddenColumns}
            w={"75vw"}
            h={"69vh"}
        />

        <GestSaveButton
            alignment='right'
            label={props.lang?.save}
            onclick={() => createForm.current?.requestSubmit()}
            loading={loading}
        /></>;
};
export default React.memo(CreatePlanForm);